export class CurrencyView {
    constructor(
        public id: number,
        public code: string,
        public name: string) { }
}
